export const handleRangeChange = (clickedDate, customRange, setCustomRange) => {
    if (!clickedDate) return;

    // no start date → set startDate
    if (!customRange.startDate) {
      setCustomRange({ startDate: clickedDate, endDate: null });
      return;
    }

    // if startDate exists but no endDate
    if (customRange.startDate && !customRange.endDate) {
      // same date → ignore
      if (clickedDate.isSame(customRange.startDate, "day")) return;

      // if earlier date clicked → start fresh
      if (clickedDate.isBefore(customRange.startDate, "day")) {
        setCustomRange({ startDate: clickedDate, endDate: null });
        return;
      }

      // normal case → set endDate
      setCustomRange({
        startDate: customRange.startDate,
        endDate: clickedDate,
      });
      return;
    }

    // both selected → reset and set new start
    setCustomRange({ startDate: clickedDate, endDate: null });
  };

  export const handleSingleChange = (date, setCustomDate) => {
    setCustomDate(date);
  };

  export const handleApply = (onApply, setApply, onClose) => {
    onApply("custom");
    setApply(true);
    onClose();
  };